import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Location } from "../../data/location";
import { ResponseBase } from "../../data";

export interface LocationState {
  response: ResponseBase | null
  isLoading: boolean;
  locationList: Location[];
  locationCount: number;
  requestFinished: boolean;
  error: ResponseBase | null;
}

const initialLocationState: LocationState = {
  response: null,
  isLoading: false,
  locationList: [],
  locationCount: 0,
  requestFinished: false,
  error: null
};

const locationSlice = createSlice({
  name: "locationSlice",
  initialState: initialLocationState,
  reducers: {
    setResponse(state, action: PayloadAction<ResponseBase | null>) {
      state.response = action.payload;
      state.isLoading = false;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
      state.locationCount = 0;
    },
    setLocationList(state, action: PayloadAction<Location[]>) {
      state.locationList = action.payload;
      state.isLoading = false;
    },
    addLocations(state, action: PayloadAction<Location[]>) {
      state.isLoading = false;
      state.locationList = state.locationList.concat(action.payload);
    },
    setLocationCount(state, action: PayloadAction<number>) {
      state.locationCount = action.payload;
    },
    setError(state, action: PayloadAction<ResponseBase | null>) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setRequestFinished(state, action:PayloadAction<boolean>) {
      state.requestFinished = action.payload;
      state.isLoading = false;
    }
  }
});

export const locationActions = locationSlice.actions;
export default locationSlice;
